import { render } from "./TabContacts.vue?vue&type=template&id=40262323"
import script from "./TabContacts.vue?vue&type=script&lang=js"
export * from "./TabContacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__